import React from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import ProductListing from "../Catalog/ProductListing";
import { getCityCombo, CityLandingLead, CityLandingFaq, cityLandingSchema } from "../Catalog/CityLanding";
import { getCategoryMeta } from "../Catalog/categoryMeta";
import * as endpoint from "./../../../Service/endpoints";

// "/delhi/furniture-and-appliances" - the combined-category landing pages.
// The listing below the copy shows the real full-home packages from the API.
function ComboComponent({ match }) {
  const citySlug = match.params.city;
  const page = getCityCombo(citySlug);

  // Unknown city: fall back to that city's furniture listing rather than 404.
  if (!page) {
    return <Redirect to={endpoint.getRoute("furniture", citySlug)} />;
  }

  const meta = getCategoryMeta("package");

  return (
    <React.Fragment>
      <SeoMeta
        title={page.title}
        description={page.description}
        canonical={`https://voorent.com/${citySlug}/${page.slug}`}
        image={meta.image || "https://voorent.com/logo192.png"}
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(cityLandingSchema(page))}</script>
      </Helmet>
      <HeaderComponent />
      <ProductListing
        mode="category"
        category={page.category}
        heading={page.h1}
        description={page.intro}
        className="v-listing--landing"
        lead={<CityLandingLead page={page} />}
        after={<CityLandingFaq page={page} />}
        crumbs={[
          { label: "Home", to: endpoint.getPath("") },
          { label: "Furniture & appliances", to: `/${citySlug}/${page.slug}` },
        ]}
      />
      <FooterComponent />
    </React.Fragment>
  );
}

export default ComboComponent;
